// @LTG-ID: F-072
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 02_DESIGN_SYSTEM.md, 08_FEATURES.md#F-072
// @CHANGED: 2026-02 session_001
// @OWNER: web
//
// Reading-progress bar — thin teal line under the sticky header.
// Ported from /app/source_reference/Landing Page.html lines 3151-3163.
// Updates on every scroll + a 500ms safety interval (handles dynamic content height).

import { useEffect, useRef } from "react";
import "./scroll-progress-bar.css";

export const ScrollProgressBar = () => {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const update = () => {
            const st = window.scrollY || window.pageYOffset || 0;
            const sh =
                document.documentElement.scrollHeight - window.innerHeight;
            const pct = sh > 0 ? Math.max(0, Math.min(100, (st / sh) * 100)) : 0;
            el.style.width = pct + "%";
        };

        update();
        window.addEventListener("scroll", update, { passive: true });
        window.addEventListener("resize", update);
        const interval = window.setInterval(update, 500);

        return () => {
            window.removeEventListener("scroll", update);
            window.removeEventListener("resize", update);
            window.clearInterval(interval);
        };
    }, []);

    return (
        <div className="ltg-progress" aria-hidden="true">
            <div
                ref={ref}
                id="readingProgress"
                className="ltg-progress__bar"
                data-testid="reading-progress-bar"
            />
        </div>
    );
};

export default ScrollProgressBar;
